module.exports = __webpack_public_path__ + "cover-letter-47f61a13/template-5-preview-6b2237bd2d7fb96d37d7e65916aab15f.jpg";